import React, { memo, useEffect, useState } from "react";
import generateAvatarUrl from "../../app/utils/generateAvatarUrl";
import {
  findContractLineByKey,
  getContractLineImageUrl,
} from "../../utils/marketSubjectDisplay";

/**
 * Outcome line image from contract subject, or generated letter avatar.
 */
const ContractLineAvatar = memo(function ContractLineAvatar({
  market,
  selectionKey,
  label,
  size = 22,
  className = "contract-line-avatar",
}) {
  const line = findContractLineByKey(market, selectionKey);
  const text = (label || line?.label || "").trim() || "Outcome";
  const preferred = getContractLineImageUrl(line, text);
  const fallback = generateAvatarUrl(text);
  const [src, setSrc] = useState(preferred);

  useEffect(() => {
    setSrc(preferred);
  }, [preferred]);

  const dim = { width: size, height: size, minWidth: size, minHeight: size };

  return (
    <img
      src={src}
      alt=""
      className={className}
      style={dim}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={() => {
        if (src !== fallback) setSrc(fallback);
      }}
    />
  );
});

export default ContractLineAvatar;
